<template>
  <div>
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("shift", 2) }}
      </div>
      <router-link class="btn-blue" to="shifts"
        >{{ $tc("shift", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Shifts"
          :key="index"
          v-if="item.fieldname !== 'shift_id'"
          class="col-lg-6 col-xl-4 mb-4"
        >
          <div
            v-if="
              (item.type !== 'radio') &
                (item.type !== 'time') &
                (item.fieldname != 'shift_working_hrs')
            "
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <Tooltip :title="$t(item.tooltip)" />
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">{{
                errors.first(`${item.fieldname}`)
              }}</span>
            </p>
          </div>
          <div>
            <label v-if="item.fieldname == 'shift_working_hrs'"
              >Working Hours : {{ item.fieldvalue }}</label
            >
          </div>
          <div v-if="item.type === 'radio'">
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-3">{{ $tc(item.label) }}</label>
              <label class="j-checkbox mb-0">
                <b-form-checkbox
                  type="checkbox"
                  class="j-checkbox"
                  v-model="item.fieldvalue"
                ></b-form-checkbox>
                <span class="switch-slider"></span>
              </label>
            </div>
            <p class="error_message"></p>
          </div>

          <div v-if="item.fieldname == 'shift_start_time'">
            <vue-timepicker
              manual-input
              v-model="shift_start_time"
              name="shift_start_time"
              id="shift_start_time"
              format="HH:mm"
              placeholder="Start Time"
              class="time_picker w-91"
              input-width="100%"
              auto-scroll
              lazy
              @change="onChangeShowTime($event, 'start')"
              v-validate="'required'"
            ></vue-timepicker>
            <!-- <date-picker
              v-model="item.fieldvalue"
              @change="onChangeShowTime($event,'start')"
              lang="en"
              type="time"
              format="hh:mm a"
              :minute-step="1"
              class="time_picker w-91"
              placeholder="Start Time"
              @input="onclose($event)"
              name="showtime"
              id="showtime"
              v-validate="'required'"
            ></date-picker> -->
          </div>

          <div v-if="item.fieldname == 'shift_end_time'">
            <vue-timepicker
              manual-input
              v-model="shift_end_time"
              name="shift_end_time"
              id="shift_end_time"
              format="HH:mm"
              placeholder="End Time"
              class="time_picker w-91"
              input-width="100%"
              auto-scroll
              lazy
              @change="onChangeShowTime($event, 'end')"
              v-validate="'required'"
            ></vue-timepicker>
            <!-- <date-picker
              v-model="item.fieldvalue"
              @change="onChangeShowTime($event,'end')"
              lang="en"
              type="time"
              format="hh:mm a"
              :minute-step="1"
              class="time_picker w-91"
              placeholder="End Time"
              @input="onclose($event)"
              name="showtime"
              id="showtime"
              v-validate="'required'"
            ></date-picker> -->
          </div>
        </div>
        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <!-- <button class="btn-black">{{ $t('reset') }}</button> -->
          <b-button class="btn-outline-grey" variant="default" to="shifts">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Shifts from "@/helper/formJSONMaster/Shifts";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: { DatePicker, VueTimepicker },
  data() {
    return {
      btenable: false,
      disabledDates: {
        to: new Date(2019, 9, 26)
      },
      Shifts: Shifts.ms_shifts,
      Methods: Shifts.Methods,
      submitted: false,
      st: "",
      et: "",
      shift_start_time: "",
      shift_end_time: ""
    };
  },
  beforeMount() {
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    onChangeTimePicker: function(date) {
      console.log("🚀 ~ file: editShift.vue ~ line 201 ~ date", date);
      // console.log("date :", date);
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      // this.st = strTime;
      return strTime;
      // this.movieSelected.start_time = formatAMPM(this.movieSelected.start_time);
    },
    // onChangeEndTimePicker: function(date) {
    //   var hours = date.getHours();
    //   var minutes = date.getMinutes();
    //   var ampm = hours >= 12 ? "PM" : "AM";
    //   hours = hours % 12;
    //   hours = hours ? hours : 12; // the hour '0' should be '12'
    //   minutes = minutes < 10 ? "0" + minutes : minutes;
    //   var strTime = hours + ":" + minutes + " " + ampm;
    //   this.et = strTime;
    //   return strTime;
    //   // this.movieSelected.start_time = formatAMPM(this.movieSelected.start_time);
    // },
    // convertToTime: function(value, value1) {
    //     let end_time = moment(this.movieSelected.selected_time).add(parseInt(this.movieSelected.lengthMinutes), "m").toDate();
    //     this.movieSelected.end_time = moment(end_time).format("hh:mm A");
    // },

    onclose: function(e) {},
    onChangeShowTime: function(event, type) {
      console.log("🚀 ~ file: editShift.vue ~ line 233 ~ event", event);
      event = new Date(
        moment(event.displayTime, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      if (type == "start") {
        Shifts.ms_shifts[2].fieldvalue = event;
        this.$forceUpdate();

        this.st = this.onChangeTimePicker(Shifts.ms_shifts[2].fieldvalue);
        // this.et = this.onChangeTimePicker(Shifts.ms_shifts[4].fieldvalue);
      }
      if (type == "end") {
        Shifts.ms_shifts[3].fieldvalue = event;
        this.$forceUpdate();

        // this.st = this.onChangeTimePicker(Shifts.ms_shifts[3].fieldvalue);
        this.et = this.onChangeTimePicker(Shifts.ms_shifts[3].fieldvalue);
      }
      if (this.st && this.st.length > 0 && this.et && this.et.length > 0) {
        var startTime = moment(`${this.st}`, "hh:mm a");
        var endTime = moment(`${this.et}`, "hh:mm a");
        this.Shifts.map((x, index) => {
          if (x.fieldname === "shift_working_hrs") {
            if (
              (moment(startTime, "hh:mm a").format("A") ==
                moment(endTime, "hh:mm a").format("A") &&
                moment(
                  moment().format("YYYY-MM-DD") +
                    " " +
                    startTime.format("hh:mm a")
                ).format() >=
                  moment(
                    moment().format("YYYY-MM-DD") +
                      " " +
                      endTime.format("hh:mm a")
                  ).format()) ||
              (moment(startTime, "hh:mm a").format("A") == "PM" &&
                moment(endTime, "hh:mm a").format("A") == "AM")
            ) {
              this.Shifts[index].fieldvalue =
                24 + endTime.diff(startTime, "hours");
            } else {
              this.Shifts[index].fieldvalue = endTime.diff(startTime, "hours");
            }
          }
        });
      }
    },
    onFocusHandler: function() {
      // this.submitted = false;
    },
    getEditList: function(id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id }
      });
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status) {
            let obj = data.details[0];
            this.Shifts.map(x => {
              if (x.fieldname === "shift_start_time") {
                this.st = moment(obj[x.fieldname]).format("hh:mm A");
                this.shift_start_time = moment(obj[x.fieldname]).format(
                  "HH:mm"
                );
              }
              if (x.fieldname === "shift_end_time") {
                this.et = moment(obj[x.fieldname]).format("hh:mm A");
                this.shift_end_time = moment(obj[x.fieldname]).format("HH:mm");
                this.onChangeShowTime(
                  { displayTime: this.shift_end_time },
                  "end"
                );
              }
              if (x.type === "radio") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                x.fieldvalue = this.formatDate(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    onUpdateHandler: function() {
      // let body = this.getRequestBody("PUT", this.Shifts, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/shifts"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });
      this.submitted = true;
      this.$validator.validate().then(valid => {
        console.log("valid :", valid);
        if (valid) {
          this.btenable = true;
          // Shifts.ms_shifts[3].fieldvalue = this.onChangeStartTimePicker(
          //   Shifts.ms_shifts[3].fieldvalue
          // );
          // Shifts.ms_shifts[4].fieldvalue = this.onChangeEndTimePicker(
          //   Shifts.ms_shifts[4].fieldvalue
          // );
          let body = this.getRequestBody("PUT", this.Shifts, {
            ...this.Methods,
            params: { id: this.$route.query.id }
          });
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then(response => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "/cinema-manager/shifts"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        } else {
          console.log("else :");
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/ShiftsComponents/editShift.vue